<script lang="ts">
import type { HTMLAttributes } from 'vue'
import type { AvatarVariants } from './Avatar.vue'

export interface AvatarGroupOverflowProps {
  count: number
  size?: AvatarVariants['size']
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { cn } from '#ui-kit/lib/utils'
import Avatar from './Avatar.vue'

const props = withDefaults(defineProps<AvatarGroupOverflowProps>(), {
  size: 'sm',
})
</script>

<template>
  <Avatar
    data-slot="avatar-group-overflow"
    :size="props.size"
    bordered
    :class="cn('bg-blue-700 text-xs font-medium text-white', props.class)"
  >
    +{{ props.count }}
  </Avatar>
</template>
